import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, PlugZap } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const ShopSyncCard = () => {
  const [s, setS] = useState(null);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/shop-sync/settings").then((r) => setS(r.data));
  }, []);
  if (!s) return null;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    try {
      const r = await api.put("/shop-sync/settings", { url: s.url, email: s.email, status: s.status, ...(pw ? { password: pw } : {}) });
      setS(r.data);
      setPw("");
      const t = await api.post("/shop-sync/test");
      setMsg(`${t.data.message} · ${t.data.store_products} products in your store`);
      toast.success("softspinepress.com connected");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="bg-[#FFFDF9] border border-[#2A2325]/10 p-7 space-y-5" data-testid="shop-sync-card">
      <div className="flex items-start gap-4">
        <PlugZap size={26} className="text-[#5E2B38] shrink-0" />
        <div>
          <div className="eyebrow">softspinepress.com connection</div>
          <p className="text-sm text-[#5C5255] mt-1 max-w-2xl">
            Pressing <strong>Publish</strong> on a title creates or updates it in your softspinepress.com store, with the PDF, cover, price, category and description. Your store's checkout then gives buyers the PDF. The toolkit and any app files stay here, linked from a page inside the PDF.
          </p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <label className="text-sm">Store address
          <Input value={s.url} onChange={(e) => setS({ ...s, url: e.target.value })} className="mt-1.5 rounded-none bg-white" data-testid="shop-sync-url" />
        </label>
        <label className="text-sm">Store admin email
          <Input type="email" value={s.email} onChange={(e) => setS({ ...s, email: e.target.value })} className="mt-1.5 rounded-none bg-white" data-testid="shop-sync-email" />
        </label>
        <label className="text-sm">Store admin password
          <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder={s.has_password ? "Saved (encrypted) — type to change" : "Your softspinepress.com admin password"} className="mt-1.5 rounded-none bg-white" data-testid="shop-sync-password" />
        </label>
        <label className="text-sm">New titles appear on the store as
          <select value={s.status} onChange={(e) => setS({ ...s, status: e.target.value })} className="mt-1.5 h-9 w-full border border-input bg-white px-2 text-sm" data-testid="shop-sync-status">
            <option value="live">Live — on sale immediately</option>
            <option value="draft">Draft — I'll switch it live in the store admin</option>
          </select>
        </label>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <Button type="submit" disabled={busy} className="rounded-none gap-2 bg-[#5E2B38]" data-testid="shop-sync-save-btn">
          {busy && <Loader2 size={14} className="animate-spin" />} Save & test connection
        </Button>
        {msg && <span className="text-sm text-[#2D5A3F] flex items-center gap-1.5" data-testid="shop-sync-result"><CheckCircle2 size={15} /> {msg}</span>}
      </div>
    </form>
  );
};
